define('models/calendar/item/nutrition',[
    'underscore', 'backbone', 'utils',
    // services
    'services/i18n',
    // parent
    'models/calendar/item'
], function(
    _, Backbone, U,
    // services
    i18n,
    // parent
    MCalendarItem
) {

    var MNutrition = MCalendarItem.extend({

        photos: [],
        displayName: "",
        notes: "",

        defaults: function() {
            return {
                type: MNutrition.type,
                water: 0,
                calories: 0,
                photos: this.photos,
                displayName: this.displayName,
                notes: this.notes,
            }
        }.bind(this),

        getDisplayTitle: function() {
            return this.get('displayName') || i18n.t('calendar:nutrition');
        },
        getEntries: function() {
            return this.get('entries');
        },
        setEntries: function(entries) {
            return this.set({ entries: entries });
        },

        getFavoriteData: function() {
            var data = this.pick(['entries', 'water', 'calories', 'photos']);
            data.entries = _.map(data.entries, function(entry) {
                return _.omit(entry, '_food');
            });
            return data;
        },

        // Add a photo as en entry
        setPhotoFile: function(photo, hour) {
            var newPhoto = {
                path: photo.path,
                full: photo.full,
                hour: hour,
                qty: 1
            }

            this.set('photos', this.photos);

            return newPhoto;
        },
    }, {
        ///////////////////
        // Class statics //
        ///////////////////
        type: 'nutrilog',
    });

    return MNutrition;
});

